// extracted by mini-css-extract-plugin
module.exports = {"chat":"ChatbotLinkPanel_chat__GI0Cs"};